export { useHardAgeGate } from './use-hard-age-gate';
